import React from 'react';
import { pockets, pocketsImage } from '../data/content';
const accents = ['bg-forest', 'bg-forest-soft', 'bg-gold-deep', 'bg-ink'];
export function Method() {
  return <section id="metodo" className="w-full bg-white" data-id="element-140" data-mp="74q6aevmhm6l">
      <div className="mx-auto max-w-content px-5 py-16 lg:px-8 lg:py-24" data-id="element-141" data-mp="c39rgd2e6txw">
        <div className="max-w-3xl" data-id="element-142" data-mp="h1l0ilkv50f2">
          <p className="font-display text-sm font-bold text-gold-deep" data-id="element-143" data-mp="h0jejm2b6tik">
            El método
          </p>
          <h2 className="mt-3 font-display text-3xl font-black leading-tight text-ink sm:text-4xl lg:text-5xl" data-id="element-144" data-mp="3fki5smxwvbnv">
            Cuatro bolsillos. Cada peso con una función.
          </h2>
          <p className="mt-5 text-lg leading-relaxed text-ink-muted" data-id="element-145" data-mp="3pg35gefibzug">
            En lugar de repartir tus ingresos con porcentajes rígidos que ignoran
            tu realidad, el método te da cuatro destinos claros y te enseña a
            adaptarlos a tus ingresos y prioridades, con tus propios números.
          </p>
        </div>

        <div className="mt-12 overflow-hidden rounded-2xl border border-line" data-id="element-146" data-mp="31oxofvxtz1ik">
          <img src={pocketsImage} alt="Ilustración de los cuatro bolsillos del método" className="h-48 w-full object-cover sm:h-64 lg:h-72" data-id="element-147" data-mp="pemtnduphvrn" />
        </div>

        <div className="mt-10 grid gap-px overflow-hidden rounded-2xl border border-line bg-line md:grid-cols-2" data-id="element-148" data-mp="fotiuf2e1kog">
          {pockets.map((pocket, index) => <article key={pocket.id} className="flex h-full flex-col bg-white p-7 lg:p-8" data-id="element-149" data-mp="blx9leyqn0x6" data-mpi={index}>
              <div className="flex items-center gap-3" data-id="element-150" data-mp="6q87p4z8x7xp">
                <span className={`flex h-9 w-9 items-center justify-center rounded-md font-display text-sm font-bold text-cream ${accents[index]}`} data-id="element-151" data-mp="1pkfifza6l1w">
                  {pocket.id}
                </span>
                <span className="text-xs font-semibold uppercase tracking-wide text-ink-muted" data-id="element-152" data-mp="3ovbh31w8w63x">
                  {pocket.role}
                </span>
              </div>
              <h3 className="mt-5 font-display text-xl font-extrabold text-ink" data-id="element-153" data-mp="1n36p5qeqx8t7">
                {pocket.name}
              </h3>
              <p className="mt-3 text-base leading-relaxed text-ink-muted" data-id="element-154" data-mp="3glnm75zuq0ul">
                {pocket.description}
              </p>
            </article>)}
        </div>
      </div>
    </section>;
}